import { render, staticRenderFns } from "./ControlInput.vue?vue&type=template&id=48873d8a&"
import script from "./ControlInput.vue?vue&type=script&lang=js&"
export * from "./ControlInput.vue?vue&type=script&lang=js&"
import style0 from "./ControlInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports